import Api from '@/services/Api'

export default {
  showThresholdPerCareUser (params) {
    return Api().post('careUserThreshold', params)
  },
  updateLowOrHigh (params) {
    return Api().post('updUserThreshold', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/UserThresholdService.js